// extracted by mini-css-extract-plugin
module.exports = {"touch":"entity_block_line_hover_hyperlink-module__touch--1YuGC","link":"entity_block_line_hover_hyperlink-module__link--2Eoac"};